import React, { useEffect, useState } from 'react';
import { Container, Typography, Grid, Box, Button, Snackbar, Alert, Card, CardContent,
   Stack, Dialog, DialogTitle, DialogContent, DialogActions, Divider, TextField
} from '@mui/material';
import OrganizationsHeader from '../dashboardnavebar';
import { useNavigate } from 'react-router-dom';
import { OrganizationHiretech } from '../../../helper/base_url';

  const SummaryItem = ({ label, name, value, onChange, fullWidth }) => {
  const isMultiline = ['aboutCompany','roleOverview', 'responsibilities', 'deliverables', 'preferredBackground'].includes(name);

  return (
    <Grid item xs={12} sm={fullWidth ? 12 : 6}>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }} color="text.secondary">{label}</Typography>
      <TextField
        fullWidth
        size="small"
        variant="outlined"
        name={name}
        value={value || ''}
        onChange={onChange}
        multiline={isMultiline}
        minRows={isMultiline ? 3 : 1}
      />
    </Grid>
  );
};

const HireTalentSummary = () => {
  const [formData, setFormData] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });
  const [showDialog, setShowDialog] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const data = localStorage.getItem('hireTalentData');
    if (data) {
      const parsedData = JSON.parse(data);
      setFormData(parsedData);
      //console.log("Loaded formData from localStorage:", parsedData);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!formData) return;

    // Get token from localStorage
    const token = localStorage.getItem('company_token');

    try {
      const response = await fetch(`${OrganizationHiretech}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setSnackbar({ open: true, message: 'Job opportunity submitted successfully!' });
        setShowDialog(true);
        localStorage.removeItem('hireTalentData');
      } else {
        setSnackbar({ open: true, message: result.message || 'Submission failed!' });
      }
    } catch (error) {
      //console.error("Error submitting form:", error);
      setSnackbar({ open: true, message: 'Error submitting job opportunity!' });
    }
  };

  if (!formData) return null;

  return (
    <Box className="students-flex">
      <OrganizationsHeader />
      <Box  sx={{
          background: 'linear-gradient(to right, #e0f7fa, #f1f8e9)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          height : '91vh',
          overflowY: 'auto',
          padding: "40px"
        }}>
        <Container maxWidth="md">
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Review Your {formData.category} Opportunity
          </Typography>
          <Typography color="text.secondary">You can make final edits before submission.</Typography>

          <Stack spacing={4} mt={4}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h6">Company & Role Information</Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                  {['companyName', 'website', 'title', 'opportunityType', 'positions', 'location', 'duration', 'aboutCompany' ].map(name => (
                    <SummaryItem key={name} label={name.replace(/([A-Z])/g, ' $1')} name={name} value={formData[name]} InputProps={{ readOnly: true }} />
                  ))}
                </Grid>
              </CardContent>
            </Card>

            <Card elevation={3}>
              <CardContent>
                <Typography variant="h6">{formData.category} Details</Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                  {[
                    'experience', 'domain', 'roleOverview', 'responsibilities', 'deliverables',
                    'skills', 'preferredBackground', 'stipendOrSalary', 'applicationDeadline',
                    'joiningDate', 'contactName', 'contactEmail', 'contactPhone', 'linkedInProfile'
                  ].map(name => (
                    <SummaryItem
                      key={name}
                      label={name.replace(/([A-Z])/g, ' $1')}
                      name={name}
                      value={formData[name]}
                      onChange={handleChange}
                      fullWidth={['skills', 'responsibilities', 'deliverables', 'roleOverview', 'preferredBackground'].includes(name)}
                    />
                  ))}
                </Grid>
              </CardContent>
            </Card>
          </Stack>

          <Box mt={4} display="flex" gap={2}>
            <Button fullWidth variant="outlined" color="secondary" onClick={() => navigate('/organizations/hire-tech-talents')}>
              Back & Edit
            </Button>
            <Button fullWidth variant="contained" color="primary" onClick={handleSubmit}>
              Submit Job Opportunity
            </Button>
          </Box>

          <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
            <Alert severity="info" onClose={() => setSnackbar({ ...snackbar, open: false })}>
              {snackbar.message}
            </Alert>
          </Snackbar>

          <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
            <DialogTitle> Congratulations!</DialogTitle>
            <DialogContent>
              <Typography>Your {formData.opportunityType} opportunity has been submitted successfully.</Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
              <Button color="secondary" onClick={() => setShowDialog(false)}>Close</Button>
              <Button variant="contained" color="primary" onClick={() => navigate('/organizations/dashboard/pending-project')}>
                Go to Dashboard
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    </Box>
  );
};

export default HireTalentSummary;
